import { useStyletron } from 'parkdepot-shared/theme'
import React, { FC } from 'react'
import { Lot } from '../../../../types/lot.interface'
import FlexContainer from '../../../../components/style/FlexContainer.style'
import Text from '../../../../components/style/Text.style'
import { useTranslation } from 'react-i18next'
import OpeningHoursSection from '../../../Lot/components/OpeningHoursSection/OpeningHoursSection.component'

interface Props {
    lot: Lot | null
    boldedTitles?: boolean
    column?: boolean
}

const LotInfo: FC<Props> = ({ lot, boldedTitles = false, column = false }) => {
    const { address, city, name } = lot || {}
    const [css, theme] = useStyletron()

    const { t } = useTranslation()

    return (
        <>
            <FlexContainer alignitems="unset" $column={column}>
                <Text
                    className={css({ width: '12.5rem' })}
                    fontWeight={boldedTitles ? 700 : 400}
                    typography={theme.typography.ParagraphMedium}
                >
                    {t('checkout.parkingSpace')}
                </Text>
                <div>
                    <Text
                        className={css({ display: 'block' })}
                        fontWeight={400}
                        typography={theme.typography.ParagraphMedium}
                    >
                        {name}
                    </Text>
                    <div>
                        <Text fontWeight={400} typography={theme.typography.ParagraphMedium}>
                            {address}
                        </Text>
                    </div>
                    <div>
                        <Text fontWeight={400} typography={theme.typography.ParagraphMedium}>
                            {city}
                        </Text>
                    </div>
                </div>
            </FlexContainer>
            <div
                className={css({
                    marginTop: '16px'
                })}
            >
                <Text
                    className={css({ width: '12.5rem' })}
                    typography={theme.typography.ParagraphMedium}
                    fontWeight={boldedTitles ? 700 : 400}
                >
                    {t('checkout.openingHours')}
                </Text>
                <div
                    className={css({
                        [theme.mediaQuery.large]: {
                            marginTop: '-8px'
                        }
                    })}
                >
                    {lot && lot?.opening_hours && (
                        <OpeningHoursSection
                            openingHours={lot?.opening_hours.opening_hours_rrules}
                            showLabels={false}
                        />
                    )}
                </div>
            </div>
        </>
    )
}

export default LotInfo
